import React from 'react';
import PropTypes from 'prop-types';

import RichText from 'dpl/prismic/components/RichText';
import SmartImage from 'dpl/components/SmartImage';
import {
  ArticleGroupArticlePropTypes,
  HubPropTypes
} from 'dpl/prismic/utils/customPropTypes';
import BylineNames from 'dpl/prismic/article/components/BylineNames';
import { getArticlePath } from 'dpl/prismic/utils';
import ViewAllLink from 'dpl/prismic/components/ViewAllLink';

export default function ArticleGroupTiles({ articles, headline, hubPage }) {
  return (
    <div className="PrismicArticleTiles">
      <div className="mb6 flex align-items-center">
        <div className="flex-auto">
          <p className="fw-medium f6 f7-md lh-title">{headline}</p>
        </div>
        {hubPage && hubPage.id && (
          <div className="d-none d-lg-block">
            <ViewAllLink hubPage={hubPage} />
          </div>
        )}
      </div>
      <ul className="row">
        {articles.map((article, idx) => {
          const authors = article.data.authors
            .map(f => f.author.data)
            .filter(Boolean);
          return (
            <li className="col-6 col-lg-3" key={idx}>
              <a className="mb8 db" href={getArticlePath(article)}>
                <div className="mb4 relative overflow-hidden br1 f0">
                  <div className="aspect-ratio aspect-ratio--6x4">
                    <div className="aspect-ratio--object grow transition">
                      {article.data.seo_image && (
                        <SmartImage
                          alt={article.data.seo_image.alt}
                          className="w-100 h-100 bg-center cover"
                          src={article.data.seo_image.url}
                          Tag="div"
                          lazy
                        />
                      )}
                    </div>
                  </div>
                </div>
                <p className="mb2 fw-medium">
                  {RichText.asText(article.data.title)}
                </p>
                {authors.length > 0 && (
                  <div className="f2">
                    By&nbsp;
                    <BylineNames authors={authors} />
                  </div>
                )}
              </a>
            </li>
          );
        })}
      </ul>
      {hubPage && hubPage.id && (
        <div className="d-lg-none tc">
          <ViewAllLink hubPage={hubPage} />
        </div>
      )}
    </div>
  );
}

ArticleGroupTiles.propTypes = {
  articles: PropTypes.arrayOf(ArticleGroupArticlePropTypes).isRequired,
  headline: PropTypes.string.isRequired,
  hubPage: HubPropTypes
};

ArticleGroupTiles.defaultProps = {
  hubPage: null
};
